export class GlobalConstants {
  public static urlBase: string = "";
  public static lang: string = "";
}
